/**************************************
  store-hours.js

  - "Closing soon" if < 1 hour to close
  - "Opening soon" if < 1 hour to open
  - "Opens [DayOfWeek] at X" if closed
  - 24 => 12:00 am fix
  - Special dates/holidays
**************************************/

(function() {
  /* ================================
     1) Define your store hours
     ================================ */
  var storeHours;
  if (typeof window.storeHoursData !== 'undefined') {
    storeHours = {
      0: { open: window.storeHoursData.sunday_open,    close: window.storeHoursData.sunday_close },
      1: { open: window.storeHoursData.monday_open,    close: window.storeHoursData.monday_close },
      2: { open: window.storeHoursData.tuesday_open,   close: window.storeHoursData.tuesday_close },
      3: { open: window.storeHoursData.wednesday_open, close: window.storeHoursData.wednesday_close },
      4: { open: window.storeHoursData.thursday_open,  close: window.storeHoursData.thursday_close },
      5: { open: window.storeHoursData.friday_open,    close: window.storeHoursData.friday_close },
      6: { open: window.storeHoursData.saturday_open,  close: window.storeHoursData.saturday_close }
    };
  } else {
    // fallback
    storeHours = {
      0: { open: 11, close: 17 }, // Sunday: 11am-5pm
      1: { open: 10, close: 18 }, // Monday: 10am-6pm
      2: { open: 10, close: 18 }, // Tuesday
      3: { open: 10, close: 18 }, // Wednesday
      4: { open: 10, close: 18 }, // Thursday
      5: { open: 10, close: 18 }, // Friday
      6: { open: 10, close: 18 }  // Saturday
    };
  }

  /* ===================================
     2) Special or holiday dates
     ===================================
     - null => closed all day
     - {open: X, close: Y} => custom hours
  */
  var specialDates = (typeof window.specialDatesData !== 'undefined')
    ? window.specialDatesData
    : {};
  
  /* ====================================
     3) Your store's time zone
     ==================================== */
  var storeTimeZone = 'America/Toronto';

  /* ==========================================
     4) Get current time in store's time zone
     ========================================== */
  var now   = moment().tz(storeTimeZone);
  var today = now.day();  // Sunday=0, Monday=1, ...
  var hour  = now.hour(); // 0-23 (e.g., 13 for 1pm)

  /* ====================================
     5) Where we'll put the message
     ==================================== */
  var snippetDiv = document.getElementById('store-hours-location');
  if (!snippetDiv) return;

  /* ========================================================
     6) Format 24-hour -> "12:00 am/pm EST" + SVG caret
     ======================================================== */
  function formatHour(h) {
    // If h=24, treat it like 0 (midnight)
    if (h === 24) {
      h = 0;
    }
    var ampm = (h >= 12) ? 'pm ET' : 'am ET';
    var hour12 = (h % 12) || 12;

    // Inline SVG icon
    var caretIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon-caret-hours" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></path></svg>';

    return hour12 + ':00' + ampm + ' ' + caretIcon;
  }

  /* ==================================================================
     7) Find the next open day/time + day of the week for "Opens X"
     ================================================================== */
  function getNextOpen(dayIndex) {
    // We'll loop up to 7 days ahead
    for (var i = 0; i < 7; i++) {
      var checkDayIndex = (dayIndex + i + 1) % 7;
      var nextDate = now.clone().add(i + 1, 'days');
      var nextDateKey = nextDate.format('YYYY-MM-DD');
      var nextDayName = nextDate.format('dddd'); // e.g. "Sunday"

      // 1) Check if there's a special date override
      if (specialDates[nextDateKey] !== undefined) {
        if (specialDates[nextDateKey] === null) {
          // closed all day, keep searching
          continue;
        } else {
          // custom open/close
          var openHr = specialDates[nextDateKey].open;
          return {
            dayName: nextDayName,
            time: formatHour(openHr)
          };
        }
      }

      // 2) If no special date, check normal schedule
      var nextDaySchedule = storeHours[checkDayIndex];
      if (nextDaySchedule) {
        return {
          dayName: nextDayName,
          time: formatHour(nextDaySchedule.open)
        };
      }
    }
    // If never found an open day
    return { dayName: '???', time: '??' };
  }

  /* =========================================
     8) Check if today is special or normal
     ========================================= */
  var dateKey = now.format('YYYY-MM-DD');
  var schedule;

  if (specialDates[dateKey] !== undefined) {
    // A special day
    if (specialDates[dateKey] === null) {
      // closed all day
      var nxt = getNextOpen(today);
      snippetDiv.innerHTML = '<span class="store-status">Closed</span>' + '<span class="store-status-hours">  – Opens ' + nxt.dayName + ' at ' + nxt.time + '</span>';
      return;
    } else {
      schedule = specialDates[dateKey];
    }
  } else {
    // normal day
    schedule = storeHours[today];
  }

  // If we didn't find a schedule => closed all day
  if (!schedule) {
    var nxt2 = getNextOpen(today);
    snippetDiv.innerHTML = '<span class="store-status">Closed</span>' + '<span class="store-status-hours"> – Opens ' + nxt2.dayName + ' at ' + nxt2.time + '</span>';
    return;
  }

  var openHr  = schedule.open;
  var closeHr = schedule.close;

  /* =====================================================
     9) Decide open/closed + "closing soon" / "opening soon"
     =====================================================
       - If hour < (openHr - 1): "Closed – Opens at X"
       - If openHr-1 <= hour < openHr: "Closed – Opening soon at X"
       - If openHr <= hour < (closeHr - 1): "Open – Closes at X"
       - If (closeHr - 1) <= hour < closeHr: "Open – Closing soon at X"
       - Else (hour >= closeHr): "Closed – Opens [DayOfWeek] at X"
  */
  if (hour < openHr - 1) {
    snippetDiv.innerHTML = '<span class="store-status">Closed</span>' + '<span class="store-status-hours"> – Opens today at ' + formatHour(openHr) + '</span>';
  } else if (hour >= (openHr - 1) && hour < openHr) {
    snippetDiv.innerHTML = '<span class="store-status">Closed</span>' + '<span class="store-status-hours"> – Opening soon at ' + formatHour(openHr) + '</span>';
  } else if (hour >= openHr && hour < (closeHr - 1)) {
    snippetDiv.innerHTML = '<span class="store-status">Open</span>' + '<span class="store-status-hours"> – Closes at ' + formatHour(closeHr) + '</span>';
  } else if (hour >= (closeHr - 1) && hour < closeHr) {
    snippetDiv.innerHTML = '<span class="store-status">Open</span>' + '<span class="store-status-hours"> – Closing soon at ' + formatHour(closeHr) + '</span>';
  } else {
    var nxt3 = getNextOpen(today);
    snippetDiv.innerHTML = '<span class="store-status">Closed</span>' + '<span class="store-status-hours"> – Opens ' + nxt3.dayName + ' at ' + nxt3.time + '</span>';
  }

})();
